import { useSettings } from '@/hooks/useSettings'
import { formatPrice } from '@/lib/utils'

export function Marquee() {
  const { marquee, storefront } = useSettings()
  const threshold = storefront?.freeShippingThresholdKobo
  const defaultItems = threshold
    ? ['fine fragrances', 'sample first', 'refillable', 'cruelty-free', 'made to discover', `free shipping over ${formatPrice(threshold)}`]
    : ['fine fragrances', 'sample first', 'refillable', 'cruelty-free', 'made to discover']
  const items = marquee?.items?.length ? marquee.items : defaultItems

  return (
    <section className="border-y border-line bg-card py-5">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...items, ...items, ...items].map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="mx-8 font-condensed text-xs normal-case tracking-[0.2em] text-carbon"
          >
            {item}
          </span>
        ))}
      </div>
    </section>
  )
}
